import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getSettingsError,
  getSettingsSuccess,
  postCellSettingsError,
  postCellSettingsRequest,
  postCellSettingsSuccess,
  postSettingsError,
  postSettingsRequest,
  postSettingsSuccess,
} from './actions';
import { GET_SETTINGS_REQUEST, POST_CELL_SETTINGS_REQUEST, POST_SETTINGS_REQUEST } from './constants';
import { CellService } from '../../../../../entities/Cell/services';
import { ReservationsService } from '../../../../../entities/Reservations';

function* postCellSettingRequestSaga(action: ReturnType<typeof postCellSettingsRequest>) {
  try {
    const body = action.payload;
    yield call(CellService.postCellSett, body);

    yield put(postCellSettingsSuccess());
  } catch (error: any) {
    yield put(postCellSettingsError(error));
  }
}

function* getSettingRequestSaga() {
  try {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;
    // @ts-ignore
    const res: any = yield call(ReservationsService.getSettings, branchId);

    yield put(getSettingsSuccess(res));
  } catch (error: any) {
    yield put(getSettingsError(error));
  }
}

function* postSettingRequestSaga(action: ReturnType<typeof postSettingsRequest>) {
  try {
    const body = action.payload;
    yield call(ReservationsService.putSettings, body);

    yield put(postSettingsSuccess());
  } catch (error: any) {
    yield put(postSettingsError(error));
  }
}

export function* cellSettingsSagaWatcher() {
  yield takeLatest(POST_CELL_SETTINGS_REQUEST, postCellSettingRequestSaga);
  yield takeLatest(GET_SETTINGS_REQUEST, getSettingRequestSaga);
  yield takeLatest(POST_SETTINGS_REQUEST, postSettingRequestSaga);
}
